<template>
  <component :is="colWrapper" v-bind="colProps">
    <validation-provider
      v-slot="validationContext"
      :name="validation_field_name || label"
      :rules="rules"
    >
      <b-form-group :label="label" :label-for="id">
        <v-select
          :value="value"
          :options="options"
          :reduce="reduce"
          :placeholder="placeholder"
          :multiple="multiple"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          @input="$emit('input', $event)"
          class="w-100"
          append-to-body
          :calculate-position="withPopper"
          :disabled="disabled"
        />
        <b-form-invalid-feedback :state="getValidationState(validationContext)">
          {{ validationContext.errors[0] }}
        </b-form-invalid-feedback>
      </b-form-group>
    </validation-provider>
  </component>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import { watch, computed } from "@vue/composition-api";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  name: "BaseSelect",
  components: {
    ValidationProvider,
    vSelect,
  },
  props: {
    value: {
      default: "",
    },
    validation_field_name: {
      type: String,
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    reduce: {
      type: Function,
      default: (option) => option,
    },
    cols: {
      type: [String, Number],
      default: null,
    },
    getValidationState: {
      type: Function,
      default: () => {},
    },
  },
  setup(props) {
    const colWrapper = computed(() => (props.cols ? "b-col" : "div"));

    const colProps = computed(() => (props.cols ? { cols: props.cols } : {}));

    return {
      colProps,
      colWrapper,
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>